export default {
  en: {
    keyword: 'Keyword',
    termsOfPayment: 'Terms of Payment',
    name: 'Name',
    detail: 'Detail',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions',
    updatedTermsOfPaymentMessage: 'This terms of payment has been updated',
    deletedTermsOfPaymentMessage: 'This terms of payment has been deleted'
  },
  th: {
    keyword: 'คำที่ต้องการค้นหา',
    termsOfPayment: 'เงื่อนไขการชำระเงิน',
    name: 'ชื่อ',
    detail: 'รายละเอียด',
    selectedVersion: 'ข้อมูลที่เลือก',
    latestVersion: 'ข้อมูลล่าสุด',
    updatedTermsOfPaymentMessage: 'เงื่อนไขการชำระเงินนี้มีการแก้ไข',
    deletedTermsOfPaymentMessage: 'เงื่อนไขการชำระเงินนี้ถูกลบไปแล้ว'
  }
}
